export const isAdmin = () => {
    var loggedIn = document.cookie.split(`loggedIn=`)
    if (loggedIn.length === 2 && loggedIn[1].split(';')[0] === 'admin') {
      return true
    } else {
      return false
    }  
}

export const isLoggedIn = () => {
  var loggedIn = document.cookie.split(`loggedIn=`).length === 2;
  if (loggedIn) {
    return true
  } else {
    return false
  }
}
